<!-- Actions -->
<button
    app-button
    buttonSize="xsmall"
    [buttonTheme]="theme"
    [matMenuTriggerFor]="nodeActions">
    <app-icon icon="ellipsis-v"></app-icon>
</button>

<!-- Main manu -->
<mat-menu #nodeActions="matMenu" [overlapTrigger]="true">
    <!-- Select -->
    <ng-container *appFlagApplication="application.Viewer; mode:'exclude'">
        <button mat-menu-item [matMenuTriggerFor]="selectActions">Select</button>
        <mat-divider></mat-divider>
    </ng-container>
    
    <!-- Show / Hide -->
    <button mat-menu-item (click)="toggleVisible(node, true)" *ngIf="!node.boolState.shown">Show</button>
    <button mat-menu-item (click)="toggleVisible(node, false)" *ngIf="node.boolState.shown">Hide</button>    

    <!-- Isolate -->
    <button mat-menu-item (click)="hideInverse(node)">Isolate</button>

    <!-- Fade -->
    <mat-divider></mat-divider>
    <button mat-menu-item [matMenuTriggerFor]="fadeActions">Fade</button>
    
    <!-- Pickable / Unpickable -->
    <ng-container *appFlagApplication="application.Loft">
        <mat-divider></mat-divider>
        <button mat-menu-item [matMenuTriggerFor]="pickableActions">Pickable / Unpickable</button>
    </ng-container>

    <!-- Fly To -->
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="flyToNode(node)">Fly To</button>
</mat-menu>

<!-- Select submenu -->
<mat-menu #selectActions="matMenu">
    <button mat-menu-item (click)="checkNode(node, true)">Select This</button>
    <button mat-menu-item (click)="checkInverse(node)">Select Everything Else</button>
</mat-menu>

<!-- Fade submenu -->
<mat-menu #fadeActions="matMenu">
    <button mat-menu-item (click)="fadeNode(node)">Fade This</button>
    <button mat-menu-item (click)="fadeInverseNodes(node)">Fade Everything Else</button>
</mat-menu>

<!-- Show / Hide submenu -->
<mat-menu #showHideActions="matMenu">
    <button mat-menu-item (click)="toggleVisible(node, true)" *ngIf="!node.boolState.shown">Show This</button>
    <button mat-menu-item (click)="toggleVisible(node, false)" *ngIf="node.boolState.shown">Hide This</button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="hideInverse(node)">Hide Everything Else</button>
</mat-menu>

<!-- Pickable submenu -->
<mat-menu #pickableActions="matMenu">
    <button *ngIf="node.boolState.pickable" mat-menu-item (click)="togglePickable(node, false)">Make Unpickable</button>
    <button *ngIf="!node.boolState.pickable" mat-menu-item (click)="togglePickable(node, true)">Make Pickable</button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="toggleInversePickable(node, false)">Make Everything Else Unpickable</button>
</mat-menu>
